import React from 'react';
import { Link } from 'react-router';
import PerformanceBadge from '../Operations/PerformanceBadge';
import EsrrBadge from '../Operations/EsrrBadge';
import { MiciCaseItem } from '../../services/types/MiciCases';
import { Cell } from '../../shared/components/Table';
import { customDateStr } from '../../shared/misc/utils';
import StatusBadge from './StatusBadge';
import ImpactBadge from '../Operations/ImpactBadge';
import RiskBadge from '../Operations/RiskBadge';
import { Button } from '../../shared/components';
import RelatedOperations from './RelatedOperations';

const getCells = (
  hideColumns: string[],
  showCause: (rationaleType: string, rationale: string) => void,
  operationId?: number
) => {
  const cells: Cell<MiciCaseItem>[] = [
    {
      name: 'number',
      value: (x) => x.number,
      render: (x, o) => (
        <Link
          to={
            operationId
              ? `/mici-cases/${o.number}?operationNumber=${o.operationNumber}`
              : `/mici-cases/${o.number}`
          }
        >
          {x}
        </Link>
      ),
      column: 'miciNumber',
    },
    {
      name: 'operationNumber',
      value: (x) => x.operationNumber,
      render: (x, o) => <Link to={`/operations/${o.operationNumber}`}>{x}</Link>,
    },
    {
      name: 'receiptDate',
      value: (x) => customDateStr(x.receiptDate),
    },
    {
      name: 'registerDate',
      value: (x) => customDateStr(x.registerDate),
    },
    {
      name: 'stage',
      value: (x) => x.stage,
      column: 'miciStage',
    },
    {
      name: 'status',
      value: (x) => x.status,
      column: 'miciStatus',
      render: (x) => <StatusBadge code={x} />,
    },
    {
      name: 'causes',
      value: (x) => x.causes,
      sortDisabled: true,
      render: (v, obj) => (
        <Button
          htmlId={`esrr_button_${obj.id}`}
          className="btn-tertiary no-padding"
          icon="clipboard-list"
          text=""
          onClick={() => showCause('causes', v)}
          title="Causes"
        />
      ),
    },
    { name: 'operationName', value: (x) => x.operationName },
    { name: 'operationStage', value: (x) => x.operationStage },
    { name: 'operationSector', value: (x) => x.operationSector, column: 'sectorSubSector' },
    { name: 'regionCountry', value: (x) => x.regionCountry },
    {
      name: 'operationEsic',
      value: (x) => x.operationEsic,
      column: 'esic',
      render: (x) => <ImpactBadge text={x} />,
    },
    {
      name: 'operationDccrc',
      value: (x) => x.operationDccrc,
      column: 'dccrc',
      render: (x) => <RiskBadge text={x} />,
    },
    {
      name: 'operationEsrr',
      value: (x) => x.operationEsrr,
      column: 'esrr',
      render: (x) => <EsrrBadge text={x} />,
    },
    {
      name: 'operationSpr',
      value: (x) => x.operationSpr,
      column: 'spr',
      render: (x) => <PerformanceBadge code={x} />,
    },
    {
      name: 'operationSRDate',
      value: (x) => customDateStr(x.operationSRDate),
    },
    {
      name: 'operationDisbursementDate',
      value: (x) => customDateStr(x.operationDisbursementDate),
    },
    { name: 'operationDisbursed', value: (x) => x.operationDisbursed },
    {
      name: 'closingDate',
      value: (x) => customDateStr(x.closingDate),
    },
    {
      name: 'operationPrimaryMember',
      value: (x) => x.operationPrimaryMember,
      column: 'primaryMember',
      sortDisabled: true,
    },
    {
      name: 'operationMembers',
      value: (x) => x.operationMembers,
      column: 'esgMembers',
      sortDisabled: true,
    },
    { name: 'operationTeamLeader', value: (x) => x.operationTeamLeader },
    { name: 'caseClosure', value: (x) => customDateStr(x.caseClosure) },
    {
      name: 'relatedOperations',
      render: (v, obj) => <RelatedOperations operations={obj.relatedOperations} />,
    },
  ];

  return cells.filter(
    (c) => c.name && (!c.disable || !c.disable()) && !hideColumns.includes(c.name)
  );
};

export default getCells;
